import { canonicalFitnessLocalWorkout, type FitnessLocalWorkoutEnvelope } from './fitnessLocalWorkoutDomain.ts';

export const FITNESS_DRAFT_DISCARD_TOOL = 'propose_fitness_local_draft_discard';
export interface FitnessDraftDiscardArgs { action: 'discard_saved_draft'; snapshot: FitnessLocalWorkoutEnvelope }
const object = (value: unknown): value is Record<string, unknown> => value !== null && typeof value === 'object' && !Array.isArray(value);
const invalid = (): never => { throw new Error('invalid_fitness_draft_discard'); };

/** A minimal device projection stages a review; it never authorizes deletion. */
export function canonicalDiscardArgs(input: unknown, owner: string, now: Date = new Date()): FitnessDraftDiscardArgs {
  if (!object(input) || Object.keys(input).length !== 2 || !Object.prototype.hasOwnProperty.call(input, 'action') || !Object.prototype.hasOwnProperty.call(input, 'snapshot') || input.action !== 'discard_saved_draft') return invalid();
  const snapshot = canonicalFitnessLocalWorkout(input.snapshot, owner, now);
  if (snapshot.status !== 'available' || snapshot.summary === null) return invalid();
  return { action: 'discard_saved_draft', snapshot };
}
